import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from "prop-types";

export default function CsfFournisseurPagination({ startRow, offset, total, setStartRowFunction }) {

  const [pageFinderInputId] = useState("Page" + uuidv4());

  const isFirstPage = startRow === 1;
  const isLastPage = startRow + offset > total;
  const newOffset = (startRow + offset) - 1;
  const pageTotal = (newOffset > total) ? total : newOffset;

  const totalPageCount = Math.floor(total / offset) + ((Math.ceil(total / offset) === Math.floor(total / offset)) ? 0:1);
  const currentPage = Math.ceil(startRow / offset);

  let index = 1;
  const paginationNumbers = Array.from({ length: (totalPageCount) }, (_, index) => index + 1);


  // newPageNumber is  used on submit of Page Finder
  let newPageNumber = currentPage;
  function setPageNumber(val) {
    let inputIsValid = true;
    // for the Page Finder: only allow setting new value if valid
    if (!isNaN(Number(val))) {
      // this is a number: check if above 0 and under total number of page.
      let newValue = Number(val);
      if (newValue < 1) {
        // set 1 as minimum page number
        newPageNumber = 1;
        inputIsValid = false;
      } else if (newValue > totalPageCount) {
        // set total number of page as maximum
        newPageNumber = totalPageCount;
        inputIsValid = false;
      } else {
        // allow new value
        newPageNumber = newValue;
      }
    } else {
      newPageNumber = currentPage;
      inputIsValid = false;
    }

    if (!inputIsValid) {
      document.getElementById(pageFinderInputId).classList.add('error');
    } else {
      document.getElementById(pageFinderInputId).classList.remove('error');
    }
  }

  //force setting input to default page: somehow got issue with state in this context
  function setPageFinderInputValue() {
    const elem = document.getElementById(pageFinderInputId);
    if (elem) {
      elem.value = newPageNumber;
    }
  }
  // this will be called here each time the page changes
  setPageFinderInputValue();

  // force setting input to last know good value
  setPageFinderInputValue();

  function handleGoToPageSubmit(evt) {
    evt.preventDefault();
    if (!document.getElementById(pageFinderInputId).classList.contains('error')) {
      handlePaginationClick(newPageNumber, evt);
    }
  }

  /*
  * Method that handle the paginations.
  * */
  function handlePaginationClick(type, event) {
    event.preventDefault();
    if (type === 'prev') {
      setStartRowFunction((startRow - offset));
    } else if (type === 'next') {
      setStartRowFunction((startRow + offset));
    } else if (type === 'last') {
      // Go to last page
      const lastPageIndex = (Math.floor(total / offset) * offset) + 1;
      setStartRowFunction(lastPageIndex);
    } else {
      // Go to specific page, with index starting at 1
      const targetPage = type;
      setStartRowFunction((targetPage * offset) - offset + 1);
    }

    // reset Page Finder error state, if clicking on valid navigation
    document.getElementById(pageFinderInputId).classList.remove('error');

    const paginationElement = event.target.closest('.pagination');
    const currentPaginationSpan = paginationElement ? paginationElement.querySelector('span') : null;
    if (currentPaginationSpan) {
      currentPaginationSpan.focus();
    }
  }

  return (
    <>
      <nav className="pager broker-pager fournisseur-pager" role="navigation" aria-labelledby="pagination-heading">
        <div className="pagination-container">
          <div>
            <h4 id="pagination-heading" className="visually-hidden">{window.Drupal.t('pagination.title')}</h4>
            <ul className="pager__items js-pager__items pagination mb-0">
              <li className="pager__before">
                <ul>
                  {!isFirstPage ? (<>
                    <li className="pager__item pager__item--first page-item" >
                      <a href="#"
                        onClick={(event) => handlePaginationClick(1, event)}
                        title={window.Drupal.t('pagination.firstPageTitle')} className="page-link">
                        <span className="visually-hidden">{window.Drupal.t('pagination.firstPageTitleHidden')}</span>
                        <span aria-hidden="true"><i className="icon icon-csf-chevron-left"><span className="d-none">&nbsp;</span></i><i className="icon icon-csf-chevron-left"><span className="d-none">&nbsp;</span></i></span>
                      </a>
                    </li>
                    <li className="pager__item pager__item--previous page-item">
                      <a href="#"
                        onClick={(event) => handlePaginationClick('prev', event)}
                        title={window.Drupal.t('pagination.previousPageTitle')} rel="prev" className="page-link">
                        <span className="visually-hidden">{window.Drupal.t('pagination.previousPageTitleHidden')}</span>
                        <span aria-hidden="true"><i className="icon icon-csf-chevron-left"><span className="d-none">&nbsp;</span></i></span>
                      </a>
                    </li>
                  </>) : null}
                </ul>
              </li>

              {paginationNumbers.map((item) => (
                (item >= currentPage - 1 && item <= currentPage + 1) ||
                  (currentPage === 1 && item <= currentPage + 2) ||
                  (currentPage === totalPageCount && item >= currentPage - 2) ? (
                  <li key={item} className="pager__numbers">
                    <ul>
                      <li className={`pager__item page-item page-item--number ${currentPage === item ? 'is-active active' : ''}`}>
                        <a href="#"
                          onClick={(event) => handlePaginationClick(item, event)}
                          title={window.Drupal.t('pagination.pageTitle') + ' ' + item}
                          className={`paragraph--columns-width page-link ${currentPage === item ? 'is-active active' : ''}`}>
                          <span className="visually-hidden">{window.Drupal.t('pagination.page')} </span>{item}
                        </a>
                      </li>
                    </ul>
                  </li>
                ) : null
              ))}

              <li className="pager__after">
                <ul>
                  {!isLastPage && (<>
                    <li className="pager__item pager__item--next page-item">
                      <a href="#"
                        onClick={(event) => handlePaginationClick('next', event)}
                        title={window.Drupal.t('pagination.nextPageTitle')} rel="next" className="page-link">
                        <span className="visually-hidden">{window.Drupal.t('pagination.nextPageTitleHidden')}</span>
                        <span aria-hidden="true"><i className="icon icon-csf-chevron-right"><span className="d-none">&nbsp;</span></i></span>
                      </a>
                    </li>
                    <li className="pager__item pager__item--last page-item">
                      <a href="#"
                        onClick={(event) => handlePaginationClick('last', event)}
                        title={window.Drupal.t('pagination.lastPageTitle')} className="page-link">
                        <span className="visually-hidden">{window.Drupal.t('pagination.lastPageTitleHidden')}</span>
                        <span aria-hidden="true"><i className="icon icon-csf-chevron-right"><span className="d-none">&nbsp;</span></i><i className="icon icon-csf-chevron-right"><span className="d-none">&nbsp;</span></i></span>
                      </a>
                    </li>
                  </>)}
                </ul>
              </li>
            </ul>
          </div>
          <div className="page-total-container">
            {total} {window.Drupal.t('fournisseur.pagination.results.label')}{total > 1 ? 's' : ''}
          </div>

          {total > 0 && (
            <div className="page-finder-container">
              <div className="container">
                <div className="row page-finder">
                  <div className="col-auto page-finder-label">
                    <label htmlFor={pageFinderInputId}>{window.Drupal.t('pagination.PageFinder.pageTitle')}</label>
                  </div>
                  <div className="col-auto page-finder-input">
                    <input
                      id={pageFinderInputId}
                      type="number"
                      defaultValue={newPageNumber}
                      onChange={(e) => setPageNumber(e.target.value)}
                      min="1"
                      max="999"
                    />
                  </div>
                  <div className="col-auto page-finder-submit">
                    <span className="ml-1"> / {totalPageCount}</span>
                    <button type='button' className="btn-link" onClick={(e) => handleGoToPageSubmit(e)}>
                      <img src="/themes/custom/tink/dist/assets/new/page-finder.svg"
                           alt={window.Drupal.t('pagination.PageFinder.SubmitButtonLabelHidden')}/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </nav>
    </>
  )
}

// startRow = index du 1er item dans la page a charger
// offset = taille des pages
// total = nombre total d'elements dans la liste
// setStartRowFunction == fonction de callback pour changer le contenu avec le nouveau startrow
CsfFournisseurPagination.propTypes = {
  startRow: PropTypes.number,
  offset: PropTypes.number,
  total: PropTypes.number,
  setStartRowFunction: PropTypes.func,
};
